export default __webpack_public_path__ + "static/media/icon-voice-inbound-white.a58d1595.svg";